import React from 'react';
import styles from './FlatfyCopyright.module.scss';

const FlatfyCopyright = () => <section className={styles.root}>&copy; Flatfy Inc</section>;

export default FlatfyCopyright;
